import { boot } from 'quasar/wrappers'
import axios from 'axios'
import {authenticationStore} from "stores/auth";

// Be careful when using SSR for cross-request state pollution
// due to creating a Singleton instance here;
// If any client changes this (global) instance, it might be a
// good idea to move this instance creation inside of the
// "export default () => {}" function below (which runs individually
// for each client)
const api = axios.create({
  // baseURL: 'http://localhost:8000'
  baseURL: 'https://adminapp.groupeboutrais.fr'
})

api.interceptors.request.use(config => {
  const auth = authenticationStore();
  const token = auth.accessToken;

  if (token) {
    config.headers['Authorization'] = 'Bearer ' + token;
  }

  return config;
}, error => {
  return Promise.reject(error);
});

// Response interceptor
api.interceptors.response.use((response) => {
  return response;
}, async (error) => {
  const originalRequest = error.config;

  // If it's a request to refresh token and it failed, or if we already retried, then go to reject.
  if (originalRequest.url.includes('/api/token/refresh/') || originalRequest._retry) {
    if (error.response && error.response.data.code === "token_not_valid") {
      const auth = authenticationStore();
      await auth.logout();
      window.location.href = "/#/login";
    }
    return Promise.reject(error);
  }

  if (error.response && error.response.status === 401) {
    originalRequest._retry = true;

    const auth = authenticationStore();
    const refreshToken = auth.refreshToken;

    try {
      const response = await api.post('/api/token/refresh/', { refresh: refreshToken });

      auth.accessToken.value = response.data.access;
      api.defaults.headers['Authorization'] = 'Bearer ' + response.data.access;
      originalRequest.headers['Authorization'] = 'Bearer ' + response.data.access;

      return api(originalRequest);
    } catch (refreshError) {
      if (refreshError.response && refreshError.response.data.code === "token_not_valid") {
        await auth.logout();
        window.location.href = "/#/login";
      }

      return Promise.reject(refreshError);
    }
  }

  return Promise.reject(error);
});

export default boot(({ app }) => {
  // for use inside Vue files (Options API) through this.$axios and this.$api

  app.config.globalProperties.$axios = axios
  // ^ ^ ^ this will allow you to use this.$axios (for Vue Options API form)
  //       so you won't necessarily have to import axios in each vue file

  app.config.globalProperties.$api = api
  // ^ ^ ^ this will allow you to use this.$api (for Vue Options API form)
  //       so you can easily perform requests against your app's API
})

export { api }
